const productionConfig = {
BASE_PATH: 'https://isha.sadhguru.org',
  FACADE_BASE_PATH: 'https://iso-facade.sadhguru.org',
  YOUTH_OFFER_PATH: 'https://online.innerengineering.com',
  PS_MENU_API:
    'https://api.ishafoundation.org/scheduleApi/data.php?task=psmenu',
  PS_OVERSEAS_PRICING_API: 'https://online2.sadhguru.org/event/api/1/search',
  PS_PRICING_API: 'https://online.sadhguru.org/event/api/1/search',
  SCHEDULE_API_PATH: 'https://api.ishafoundation.org/scheduleApi/api.php',
  SCHEDULE_DATA_API_PATH:
    'https://api.ishafoundation.org/scheduleApi/data.php?task=preload',
  PROGRAMS_LIST_API_PATH:
    'https://api.ishafoundation.org/scheduleApi/data.php?task=list',
  PROGRAMS_API_PATH: 'https://api.ishafoundation.org/ishaapi/api/v1',
  LAT_LONG_API_PATH: 'https://iso-facade.sadhguru.org/content/get-latlong/',
  IEO_SPT_URL:
    'https://online.innerengineering.com/api/v3.0/course/support-details',
  HATHA_YOGA_PROGRAM_API_PATH: 'https://iso-hh-api.isha.in/iso_programs',
  FIND_A_TEACHER_API_PATH: 'https://iso-hh-api.isha.in/iso/teachers/finder/',
  HATHA_YOGA_REGISTRATION_FORM:
    'https://hys.isha.in/hys_portal/application/rest_api/user_register.php',
  IDY_REGISTRATION_FORM:
    'http://iso-facade.sadhguru.org/content/subscription/add',
  CSR_PARTNERWITHUS_FORM:
    'https://api-ishangam.isha.in/rl_leads',
  SADHANAPADA_WEBINAR_REGISTRATION_FORM:
    'https://iso-facade.sadhguru.org/content/bigmarker/webinar/register/iso',
  DONATE_API: 'https://api.ishafoundation.org/ishaapi/api/v1/donate/offline',
  GOY_PRICE_API: 'https://iso-facade.sadhguru.org/content/goy/get-program-info',
  SANNIDHI_PROGRAM_API:
    'https://iso-facade.sadhguru.org/content/get-program-info?type=sannidhi',
  FYD_Program_API:
    'https://online.innerengineering.com/schedule-api/v2.0/listing?page=1&category=any-category&daterange=any-date&fee=any-fee&type=any-type&invCategory=false&centerId=25&pgmTypeClassification=event&sortField=date&country=US&pgmTypeId=4',
  FREE_YOGA_DAY_REGISTRATION_FORM:
    'https://registration.innerengineering.com/ieo/newadmin/api/events/rsvp',
  MMM_PROGRAM_API:
    'https://iso-facade.sadhguru.org/content/get-program-info?type=mmm',
  PBK_PROGRAM_API:
    'https://iso-facade.sadhguru.org/content/goy/get-program-info?type=pbk',
  YANTRAINLINEFORM:
    'https://inlineform-online.sadhguru.org/inline-form.bundle.js',
  ILAINLINEFORM: 'https://inlineform-online.sadhguru.org/inline-form.bundle.js',
  USEXITPOPUPURL: 
    'https://innerengineering.sadhguru.org/lib/js/exit-popup.js',
  IEO_PRG_URL:
    'https://registration.innerengineering.com/ieo/newadmin/api/ieo/ieoPgms',
  IEO_PRS_DOMAIN: 'https://online.innerengineering.com',
  NEW_IEO_PRG_URL:
    'https://online.innerengineering.com/register-api/v2.0/ie-7-steps/pricing-details',
  IEO_REGISTER_URL:
    'https://online.innerengineering.com/register-api/v2.0/ie-7-steps/register',
  NEXT_PUBLIC_USPRS_API_URL:
    'https://registration.innerengineering.com/ieo/newadmin/api',
  NEXT_PUBLIC_GEO_API_URL:
    'https://innerengineering.sadhguru.org/edgeapi/region',
  IEO_VALIDATE_EMAIL_URL:
    'https://online.innerengineering.com/register-api/v2.0/ie-7-steps/eligibility',
  IEO_COUPON_APPLY:
    'https://online.innerengineering.com/register-api/v2.0/ie-7-steps/coupon/apply',
  LANGUAGE_UPGRADE_ELIGIBILITY:
    'https://online.innerengineering.com/register-api/v2.0/ie-7-steps/language-upgrade-eligibility',
  UPGRADE_LANGUAGE:
    'https://online.innerengineering.com/register-api/v2.0/ie-7-steps/upgrade-language',
  NEXT_PUBLIC_GPMS_URL:
    'https://payment.sadhguru.org/api/ieprs/payment-request',
  NEXT_PUBLIC_IEO_LOGIN_URL: 'https://online.innerengineering.com/LANG/7-steps',
  IEO_PRE_SIGNED_UPLOAD_URL:
    'https://online.innerengineering.com/register-api/v2.0/registration/upload-file/pre-signed-url',
  CLOUDFRONT_VIDEO_BUCKET_URL: 'https://dz8eesk2qtdx3.cloudfront.net',
  YOGA_SANDHYA_IYC_LINK:
    'https://data-online.sadhguru.org/event-register?event=yoga-sandhya-at-isha-yoga-center-coimbatore-6165',
  YOGA_SANDHYA_SSB_LINK:
    'https://online.sadhguru.org/event-register?event=yoga-sandhya-901',
  YOGA_MEDITATION_SAD_CAT: 'https://online.sadhguru.org/event/api/search',
  MARGAZHI_SADHANA_REG_URL: 'https://online.sadhguru.org/event-register?event=',
  EOE_EVENT: 'https://facade-online.sadhguru.org',
  EOE_EVENT_DOMAIN: 'https://portal-online.sadhguru.org',
  IDY_PUSH: 'https://api-ishangam.isha.in/rl_initiatives',
  UPCOMING_INITIATION_DATE:
    'https://online.innerengineering.com/api/v3.0/course/upcoming-initiation-dates',
  STATE_FROM_PINCODE:
    'https://cdi-gateway.isha.in/contactinfovalidation/api/countries',
  PUSH_LEADS: 'https://api-ishangam.isha.in',
  EMAIL_LOGIN_URL:
    'https://online.innerengineering.com/en/7-steps/public/landing?choose_login_option=password&login_hint=[EMAIL]&disable_autologin=1',
  MY_PROFILE_URL: 'https://ishalogin.sadhguru.org',
  SULABHA_PATH: 'https://sulaba.isha.in/api/sulaba',
  COOKIE_DOMAIN: '.sadhguru.org',
  ENV_NAME: 'production',
  SHORT_ENV_NAME: '',
  IS_LOG: true,
  USE_LOCAL_URL: false, // true --> can use static urls in getStaticPaths
  BUILD_URLS: {
    HOME: {
      lvl0: [],
      enabled: false,
    },
    SADHGURU: {
      lvl0: [],
      wisdom: {
        L1: [],
        L2: [],
      },
      enabled: false,
    },
    WISDOM: {
      /* lvl0: ['/en/wisdom/'], */
      wisdom: {
        L1: [],
        L2: [],
      },
      enabled: false,
    },
    HEALTH: {
      lvl0: ['/en/health'],
      health: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    CENTER: {
      lvl0: ['/en/center'],
      health: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    YM: {
      lvl0: [],
      'yoga&meditation': {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    EVENTS: {
      lvl0: [],
      events: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    OTHERS: {
      lvl0: [],
      other_pages: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    DONATION: {
      lvl0: [],
      other_pages: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    VOLUNTEER: {
      lvl0: [],
      other_pages: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    NEWS: {
      lvl0: [],
      other_pages: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    OUTREACH: {
      lvl0: [],
      other_pages: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    MSR: {
      lvl0: [],
      home_page: ['/mahashivratri/'],
      mahashivratri_child: {
        L1: [],
        L2: [],
      },
      enabled: false,
    },
    LANDING_PAGES: {
      // will build these landing pages if it is set to true
      YantraCeremony: false,
      SadhguruExclusive: false,
      SadhguruExclusiveRenew: false,
      SadhguruExclusiveEvent: false,
      SadhguruExclusiveTrial: false,
      SadhguruSannidhi: false,
      ShivangaLanding: false,
      Sadhanapada: false,
      GOY: false,
      IEO: false,
      MYY: false,
      Nagapratishta: false,
      RudrakshaDiksha: false,
      SubscribeFailure: true,
      SubscribeConfirm: true,
    },
  },
  USA_PROG_API:
    'https://online.innerengineering.com/schedule-assets/js/embed-v1.0.js',
  RECAPTCHA_KEY: '6LcjOCwaAAAAAE9OCSYsf2JJYsWjYr7iWAof6B4_',
  MIXPANEL_TOKEN: 'eb43b728e9d10e96cefd1107e319a10b',
  MIXPANEL_DEBUG: false,
  REGISTER_TR_API_URL: 'https://uat-prs-eu-api.sadhguru.org/admin/events',
};

export default productionConfig;
